import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
} from '@material-ui/core';


class FormLink extends React.Component {
    render() {
        const {
            buttonText, buttonProps, params, to,
        } = this.props;

        return (
            <form method="post" action={to}>
                {params && params.map(p => (
                    <input type="hidden" name={p.key} value={p.value} key={p.key} />
                ))}
                <Button
                    type="submit"
                    {...buttonProps}
                >
                    {buttonText}
                </Button>
            </form>
        );
    }
}

FormLink.propTypes = {
    buttonText: PropTypes.string.isRequired,
    buttonProps: PropTypes.object,
    to: PropTypes.string.isRequired,
    params: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    })),
};

FormLink.defaultProps = {
    buttonProps: null,
    params: null,
};

export default FormLink;
